import { defineComponent, h } from 'vue';
import { QSelect } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import BaseComponent from './BaseComponentMixin.jsx';

export default defineComponent({
    name: 'dropdown-multi-select-dsgn',
    mixins: [BaseComponent],
    components: { QSelect },
    data: function () {
        return {
        }
    },
    props: {
        type: null,
        schemakey: null,
    },
    render() {
        let name;
        if (!this.name)
            name = this.type || 'Unnamed';
        else if (typeof this.name === 'string')
            name = this.name + ':' + this.type || 'Unnamed';
        else
            name = this.type || this.schemakey || '';

        return (
            <div
                class={{ 'designer-container': true, selected: this.selected$ }}
                style={{ ...utils.getSize(this.controlData ? this.controlData.SizeOptions : null, this.parentType, this.$parent) }}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                <QSelect
                    outlined
                    dense
                    hide-bottom-space
                    label={this.controlData.Title || name}
                    placeholder={this.controlData.PlaceHolder}
                    readonly
                />
            </div>
        );
    }
});
